import { Button } from "@components/button";
import { BaseInput, Input } from "@components/input";
import { Modal } from "@components/modal";
import { useAdminUsers } from "@features/admin/users";
import {
  UserChangeBalanceRequest,
  UserInfoBalance,
  UserInfoEarnBalance,
} from "@features/admin/users/api";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { balanceChangeSchema } from "./schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { store } from "@app/store";
import { setSelectedBalanceType } from "@features/admin/users/slice";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  title: string;
  userBalance: UserInfoBalance | UserInfoEarnBalance;
  type: string;
  userId: string;
  isMerchant?: boolean;
};

export const BalancesModal = ({
  hideModal,
  isModalOpen,
  title,
  userBalance,
  type,
  userId,
  isMerchant = false,
}: Props) => {
  const isErnType = type.includes("Ern");
  const balanceType = isErnType ? "ern" : type;
  const ernSubType = isErnType
    ? type === "Ern_Pay_IN"
      ? "pay_in"
      : "pay_out"
    : undefined;
  const balance = getBalance(type, userBalance, isMerchant);
  const { changeUserBalance } = useAdminUsers();
  const { control, watch, handleSubmit, reset } =
    useForm<UserChangeBalanceRequest>({
      defaultValues: {
        add_balance: 0,
        balance_type: balanceType,
        current_balance: balance,
        final_balance: balance,
        type: ernSubType,
        user: userId,
      },
      resolver: yupResolver(balanceChangeSchema),
    });
  const [sum, setSum] = useState(balance);

  useEffect(() => {
    const { unsubscribe } = watch((value) => {
      // const amount = balance;
      setSum(balance + (Number(value.add_balance) ?? 0));
    });
    return () => unsubscribe();
  }, [watch, balance]);

  useEffect(() => {
    reset({
      add_balance: 0,
      balance_type: balanceType,
      current_balance: balance,
      final_balance: balance,
      comment: "",
      type: ernSubType,
      user: userId,
    });
    setSum(balance);
  }, [userBalance, type]);

  const onSubmit = (data: UserChangeBalanceRequest) => {
    data.final_balance = sum;
    store.dispatch(setSelectedBalanceType({ type, amount: sum }));
    changeUserBalance(userBalance.id, data);
    hideModal();
  };

  return (
    <Modal isOpen={isModalOpen} onClose={hideModal} title={title}>
      <form>
        <div style={{ marginBottom: "10px" }}>
          <Input
            control={control}
            label={"Текущий " + title.toLowerCase()}
            name="current_balance"
            defaultValue={balance}
            disabled
          ></Input>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <Input
            type="number"
            control={control}
            label="Сумма доначисления/списания"
            name="add_balance"
          ></Input>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <BaseInput
            label="Итоговый баланс"
            placeholder={sum.toString()}
            disabled
          ></BaseInput>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <Input control={control} label="Коммент" name="comment"></Input>
        </div>
        <Button onClick={handleSubmit(onSubmit)}>Сохранить</Button>
      </form>
    </Modal>
  );
};

const getBalance = (
  type: string,
  userBalance: UserInfoBalance | UserInfoEarnBalance,
  isMerchant: boolean,
) => {
  if (isMerchant) {
    return userBalance.amount;
  }
  if (type.includes("Ern")) {
    const earnBalance = userBalance as UserInfoEarnBalance;
    return type === "Ern_Pay_IN" ? earnBalance.pay_in : earnBalance.pay_out;
  } else {
    return userBalance.amount;
  }
};
